function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.566 11.914l-3.316-2.82c-.343-.31-.71-.45-1.006-.437a5.25 5.25 0 1 0-.588.588c-.013.295.129.662.437 1.005l2.82 3.316c.484.536 1.272.582 1.754.1.48-.48.436-1.27-.101-1.752zM5.25 8.75a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z",
  fill: "currentColor"
});

const SvgLens = props => React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  fill: "none"
}, props), _ref);

export default SvgLens;